/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, ChangeDetectionStrategy } from '@angular/core';

import { BuilderUserContext } from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';

@Component({
  standalone: false,
  selector: 'gh-setup-scheduling-tab-container',
  templateUrl: 'scheduling-tab-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SchedulingTabContainerComponent {

  constructor(private userContext: BuilderUserContext) {
  }

  hasScheduleTemplatesPermission(): boolean {
    return this.userContext.hasPermission(BuilderPermission.Setup.Schedules.ConstructionTemplates.LIST)
      || this.userContext.hasPermission(BuilderPermission.Setup.Schedules.SalesTemplates.LIST)
      || this.userContext.hasPermission(BuilderPermission.Setup.Schedules.PreConstructionTemplates.LIST)
      || this.userContext.hasPermission(BuilderPermission.Setup.Schedules.MaintenanceTemplates.LIST);
  }
}
